import { onMounted, onUnmounted, defineComponent } from 'vue';
import bugsnagClient from '@getaccept/lib-shared-new/src/bugsnag';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import BugsnagPerformance from '@bugsnag/browser-performance';
import { VueRouterRoutingProvider } from '@bugsnag/vue-router-performance';
import { languageLoaded } from './i18n/lang';
import { useLanguageStore } from './language/store/language.store';
import { initializeAnalytics } from './helpers/analytics.helper';
import router from './router';
export default defineComponent({
    name: 'App',
    setup() {
        const { language } = storeToRefs(useLanguageStore());
        const route = useRoute();
        const userId = route.params.id;
        const initBugSnagPerformanceMonitoring = () => {
            if (process.env.VUE_APP_BUGSNAG) {
                BugsnagPerformance.start({
                    apiKey: process.env.VUE_APP_BUGSNAG,
                    releaseStage: process.env.VUE_APP_BUGSNAG_RELEASE_STAGE || 'development',
                    appVersion: process.env.VUE_APP_BUGSNAG_APP_VERSION || '0.0.0',
                    routingProvider: new VueRouterRoutingProvider(router, '/'),
                });
            }
        };
        const init = () => {
            initializeAnalytics(userId, language.value);
            initBugSnagPerformanceMonitoring();
        };
        const unhandledRejectionHandler = (event) => {
            if (bugsnagClient) {
                bugsnagClient.notify(new Error(event.reason));
            }
        };
        window.addEventListener('unhandledrejection', unhandledRejectionHandler);
        onMounted(() => {
            window.addEventListener('load', init);
        });
        onUnmounted(() => {
            window.removeEventListener('load', init);
            window.removeEventListener('unhandledrejection', unhandledRejectionHandler);
        });
        return { languageLoaded };
    },
});
